import { useEffect, useState } from 'react'
import { useParams } from 'react-router'
import { useExameLocalService } from 'hooks/useExameLocalService'

export const useExameTentativaHomicidio = () => {
  const params = useParams()
  const exameLocalService = useExameLocalService()
  const [processandoExameLocal, setProcessandoExameLocal] = useState(false)
  const [exameLocal, setExameLocal] = useState({})

  useEffect(() => {
    exameLocalService.listarExameLocal(params.id, setExameLocal, setProcessandoExameLocal)
  }, [params.id])

  return {
    exameLocal,
    setExameLocal,
    processandoExameLocal,
    setProcessandoExameLocal,
    idExameRealizado: params.id,
  }
}
